export default "__VITE_ASSET__BQCgr2ms__"